// @flow

import { RECEIVED_NEWS } from './constants';
import type { ReceivedNews } from './actions';
import type { News } from '../../types';

const initialState = {
  links: {
    'load-more': null,
  },
  items: [],
};

export type State = News;

export default (state: State = initialState, action: ReceivedNews): State => {
  switch (action.type) {
    case RECEIVED_NEWS:
      return {
        // overwrite current links object
        links: action.payload.links,
        // add new items to current newsitems
        items: [
          ...state.items,
          ...action.payload.items,
        ],
      };
    default:
      return state;
  }
};
